export default __webpack_public_path__ + "static/media/merle.88607a73.png";